let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("758cM")).then(() => parcelRequire('iCHcK'));